export const upper = (value: any) => value && value.toUpperCase();
export const lower = (value: any) => value && value.toLowerCase();
export const number = (value: any) => value && value.replace(/\D/g, '');
export const maxChars = (max: any) => (value: any) => value && value.substring(0, max);
export const normalizeOTP = (value: any) => value && maxChars(6)(number(value));

export const parseAndHandleChange = (handleParse: any, setFieldValue: any) => (event: any) => {
  const value = handleParse(event.target.value);
  setFieldValue(event.target.name, value);
};

export const normalizeDate = (value: any, previousValue: any) => {
  if (!value) {
    return value;
  }

  const valueNumbers = maxChars(8)(number(value));

  // Automatically add slashes if typing forward
  if (!previousValue || value.length > previousValue.length) {
    if (valueNumbers.length === 2) {
      return `${valueNumbers}/`;
    }

    if (valueNumbers.length === 4) {
      return `${valueNumbers.slice(0, 2)}/${valueNumbers.slice(2)}/`;
    }
  }

  if (valueNumbers.length <= 2) {
    return valueNumbers;
  }

  if (valueNumbers.length <= 4) {
    return `${valueNumbers.slice(0, 2)}/${valueNumbers.slice(2)}`;
  }

  return `${valueNumbers.slice(0, 2)}/${valueNumbers.slice(2, 4)}/${valueNumbers.slice(4)}`;
};

export const handleDOBOnchange = (value: string) => value.replaceAll(/[^0-9\/]/g, '');
